import React from 'react';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { TableLevelHeader } from '../TableLevelHeader';
import { StringUtilService } from '../../../../../shared/src/services/util/string-util.service';

export const DesktopTableHeader = ({
    loyaltyLevels,
}) => {
    const { t } = useTranslations();
    const cellBaseClass = 'loyalty-levels-table-desktop__cell';

    return <>
        <div className={`${cellBaseClass} ${cellBaseClass}--first-row ${cellBaseClass}-title`}>
            {t('vipLevel')}
        </div>
        {loyaltyLevels.map(levelData => <TableLevelHeader
            key={StringUtilService.stringToKebabCase(levelData.description)}
            levelData={levelData}
            extraClass={`${cellBaseClass}-header ${cellBaseClass}--first-row`}
        />)}
    </>;
};
